module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-point-image-2-a4d4f285dd11e3f1d548f85ad5719dbb.png";